import {
	$elevated,
	$highAltitudeColor,
	$lowAltitudeColor,
	$midAltitudeColor,
	$primary,
	$success,
	$white,
	$black
} from 'constants/styles';
import {
	getHighAltitudeThresholdFt,
	lowAltitudeThreshold,
	getMidAltitudeThresholdFt
} from 'components/airSpace/airspaceConstants';
import {
	opsViewUsersCircleLayerId,
	opsViewAircraftLayerId,
	opsViewUsersCluserCircleLayerId
} from 'components/opsView/opsViewMapConstants';

export const defaultMapCenter = [-95.9325, 41.256_03]; //Center of USA

export const createMapDrawStyles = (
	fillColor = $success,
	lineColor = $white,
	pointColor = $white,
	pointIcon = 'pin'
) => {
	return [
		// LineString (in-progress or final)
		{
			id: 'gl-draw-line',
			type: 'line',
			filter: ['all', ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
			layout: {
				'line-cap': 'round',
				'line-join': 'round'
			},
			paint: {
				'line-color': lineColor,
				'line-width': 6
			}
		},

		// Polygon fill
		{
			id: 'gl-draw-polygon-fill',
			type: 'fill',
			filter: ['all', ['==', '$type', 'Polygon']],
			paint: {
				'fill-color': fillColor,
				'fill-outline-color': lineColor,
				'fill-opacity': 1
			}
		},

		// Polygon stroke
		{
			id: 'gl-draw-polygon-stroke-active',
			type: 'line',
			filter: ['all', ['==', '$type', 'Polygon']],
			paint: {
				'line-color': lineColor,
				'line-opacity': 1,
				'line-width': 6
			},
			layout: {
				'line-join': 'round',
				'line-cap': 'round'
			}
		},

		// Vertex halo (for drag handles)
		{
			id: 'gl-draw-polygon-and-line-vertex-halo-active',
			type: 'symbol',
			filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
			paint: {
				'icon-opacity': 1
			},
			layout: {
				'icon-image': 'hospital-15',
				'icon-size': 1
			}
		},

		// Vertex points (circle)
		{
			id: 'gl-draw-vertex-points',
			type: 'circle',
			filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
			paint: {
				'circle-radius': 10,
				'circle-color': lineColor,
				'circle-opacity': 0.75
			}
		},

		// Midpoints (smaller, lighter)
		{
			id: 'circle-midpoint',
			type: 'circle',
			filter: ['all', ['==', 'meta', 'midpoint'], ['==', '$type', 'Point']],
			paint: {
				'circle-radius': 5,
				'circle-color': '#000',
				'circle-opacity': 0.25
			}
		},
		{
			id: 'gl-draw-point-icon',
			type: 'symbol',
			filter: ['all', ['==', '$type', 'Point'], ['==', 'meta', 'feature']],
			layout: {
				'icon-image': pointIcon,
				'icon-size': 1,
				'icon-allow-overlap': true
			},
			paint: {
				'icon-color': pointColor
			}
		}
	];
};

// export const createMapDrawStyles = (fillColor = $success, lineColor = $white, pointIcon) => [
// 	// ACTIVE (being drawn)
// 	// line stroke
// 	{
// 		id: 'gl-draw-line',
// 		type: 'line',
// 		filter: ['all', ['==', '$type', 'LineString'], ['!=', 'mode', 'static']],
// 		layout: {
// 			'line-cap': 'round',
// 			'line-join': 'round'
// 		},
// 		paint: {
// 			'line-color': ['coalesce', ['get', 'user_lineColor'], lineColor],
// 			// 'line-dasharray': [0.2, 2],
// 			'line-width': 6
// 		}
// 	},
// 	// polygon fill
// 	{
// 		id: 'gl-draw-polygon-fill',
// 		type: 'fill',
// 		filter: ['all', ['==', '$type', 'Polygon']],
// 		paint: {
// 			'fill-color': ['coalesce', ['get', 'user_fillColor'], fillColor],
// 			'fill-outline-color': ['coalesce', ['get', 'user_lineColor'], lineColor],
// 			'fill-opacity': 1
// 		}
// 	},
// 	// polygon outline stroke
// 	// This doesn't style the first edge of the polygon, which uses the line stroke styling instead
// 	{
// 		id: 'gl-draw-polygon-stroke-active',
// 		type: 'line',
// 		filter: ['all', ['==', '$type', 'Polygon']],
// 		paint: {
// 			'line-color': ['coalesce', ['get', 'user_lineColor'], lineColor],
// 			'line-opacity': 1,
// 			'line-width': 6
// 		},
// 		layout: {
// 			'line-join': 'round',
// 			'line-cap': 'round'
// 		}
// 	},
// 	// vertex point halos
// 	{
// 		id: 'gl-draw-polygon-and-line-vertex-halo-active',
// 		type: 'symbol',
// 		filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
// 		paint: {
// 			'icon-opacity': 1
// 		},
// 		layout: {
// 			'icon-image': 'hospital-15',
// 			'icon-size': 1
// 		}
// 	},
// 	// vertex points
// 	{
// 		id: '',
// 		type: 'circle',
// 		filter: ['all', ['==', 'meta', 'vertex'], ['==', '$type', 'Point']],
// 		paint: {
// 			'circle-radius': 10, // size polygon draggable points
// 			'circle-color': ['coalesce', ['get', 'user_lineColor'], lineColor], // color polygon draggable points
// 			'circle-opacity': 0.75 // opacity polygon draggable points
// 		}
// 	},
// 	// midpoints
// 	{
// 		id: 'circle-midpoint',
// 		type: 'circle',
// 		filter: ['all', ['==', 'meta', 'midpoint'], ['==', '$type', 'Point']],
// 		paint: {
// 			'circle-radius': 5, // size polygon draggable points
// 			'circle-color': '#000', // color polygon draggable points
// 			'circle-opacity': 0.25 // opacity polygon draggable points
// 		}
// 	},
// 	//Custom Colors - set by "user_fillColor" and "user_line_color"
// 	//These style the shapes after they are drawn
// 	//From: https://gist.github.com/dnseminara/0790e53cef9867e848e716937727ab18
// 	{
// 		id: 'gl-draw-polygon-user-color',
// 		type: 'fill',
// 		filter: [
// 			'all',
// 			['==', '$type', 'Polygon'],
// 			['has', 'user_fillColor'],
// 			['has', 'user_lineColor']
// 		],
// 		paint: {
// 			'fill-color': ['get', 'user_fillColor'],
// 			'fill-outline-color': ['get', 'user_lineColor'],
// 			'fill-opacity': 1
// 		}
// 	},
// 	{
// 		id: 'gl-draw-line-user-color',
// 		type: 'line',
// 		filter: ['all', ['==', '$type', 'LineString'], ['has', 'user_lineColor']],
// 		paint: {
// 			'line-color': ['get', 'user_lineColor'],
// 			'line-width': 2
// 		}
// 	},
// 	{
// 		id: 'gl-draw-point-user-color',
// 		type: 'circle',
// 		filter: ['all', ['==', '$type', 'Point'], ['has', 'user_lineColor']],
// 		paint: {
// 			'circle-radius': 3,
// 			'circle-color': ['get', 'user_lineColor']
// 		}
// 	}
// ];

export const lineLayout = {
	'line-join': 'round',
	'line-cap': 'round'
};

export const linePaint = {
	'line-opacity': 1,
	'line-width': 6
};

export const fillPaint = {
	'fill-opacity': 1
};

/* 
Mapbox approximates 1 story to 3 meters. Reference: https://blog.mapbox.com/mapping-3d-building-features-in-openstreetmap-7685ee12712a  
Reference for building height breakdown: https://www.researchgate.net/figure/Classification-of-the-buildings-in-terms-of-building-height_tbl1_336543736
*/

export const building3DData = [
	{
		height: 0,
		color: '#ffffff'
	},
	{
		height: 9, // 1-3 floors, low-rise buildings
		color: '#853647'
	},
	{
		height: 21, // 4-6 floors, multi-story buildings
		color: '#7c3280'
	},
	{
		height: 30, // 7-9 floors, multi-story buildings
		color: '#513681'
	},
	{
		height: 50, // 10-16 floors, small high-rise buildings
		color: '#353d80'
	},
	{
		height: 100, // 17-40 floors, high-rise buildings
		color: '#32627d'
	},
	{
		height: 1000, // >40 floors, ultra-high-rise buildings
		color: '#328079'
	}
];

export const painted3DBuildings = {
	id: 'painted-3d-buildings',
	source: 'composite',
	'source-layer': 'building',
	filter: ['==', 'extrude', 'true'],
	type: 'fill-extrusion',
	minzoom: 15,
	paint: {
		'fill-extrusion-color': [
			'interpolate',
			['linear'],
			['get', 'height'],
			building3DData[0].height,
			building3DData[0].color,
			building3DData[1].height,
			building3DData[1].color,
			building3DData[2].height,
			building3DData[2].color,
			building3DData[3].height,
			building3DData[3].color,
			building3DData[4].height,
			building3DData[4].color,
			building3DData[5].height,
			building3DData[5].color,
			building3DData[6].height,
			building3DData[6].color
		],
		// Use an 'interpolate' expression to
		// add a smooth transition effect to
		// the buildings as the user zooms in.
		'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'height']],
		'fill-extrusion-base': [
			'interpolate',
			['linear'],
			['zoom'],
			15,
			0,
			15.05,
			['get', 'min_height']
		],
		'fill-extrusion-opacity': 0.7
	}
};

export const grayScale3DBuildings = {
	id: 'grayscale-3d-buildings',
	source: 'composite',
	'source-layer': 'building',
	filter: ['==', 'extrude', 'true'],
	type: 'fill-extrusion',
	minzoom: 15,
	paint: {
		'fill-extrusion-color': '#aaa',
		// Use an 'interpolate' expression to
		// add a smooth transition effect to
		// the buildings as the user zooms in.
		'fill-extrusion-height': ['interpolate', ['linear'], ['zoom'], 15, 0, 15.05, ['get', 'height']],
		'fill-extrusion-base': [
			'interpolate',
			['linear'],
			['zoom'],
			15,
			0,
			15.05,
			['get', 'min_height']
		],
		'fill-extrusion-opacity': 0.65
	}
};

export const rectangleDrawMode = 'drag_rectangle';
export const circleDrawMode = 'drag_circle';
export const polygonDrawMode = 'draw_polygon';
export const simpleSelectMode = 'simple_select';
export const directSelectMode = 'direct_select';
export const staticMode = 'static';
export const lineDrawMode = 'draw_line_string';
export const pointDrawMode = 'draw_point';

// export const defaultMapStyle = 'kittyhawkio/ckrzr4dac081917mwbg7up7sf';
export const defaultMapStyle = 'ac-default';

export const whiteListedAloftSources = ['kh-customairspace', 'hillshade'];
export const customAirspaceLineLayerId = 'kh-customairspace-line';

export const mapLabelLayersToTranslate = [
	'contour-label',
	'building-number-label',
	'block-number-label',
	// 'road-label-outdoors',
	'golf-hole-label',
	'ferry-aerialway-label',
	// 'waterway-label',
	'natural-line-label',
	'natural-point-label',
	'water-line-label',
	'water-point-label',
	// 'poi-label',
	'transit-label',
	'airport-label',
	// 'settlement-subdivision-label',
	// 'settlement-minor-label',
	// 'settlement-major-label',
	'state-label',
	'country-label',
	'kh-laanc-label',
	'kh-uasfm-airspace-ceiling-labels'
];

export const defaultMapboxStyleValue = 'mapbox://styles/mapbox/streets-v11';

export const mapboxMapStyles = [
	{
		value: 'mapbox://styles/mapbox/streets-v11',
		name: 'Streets'
	},
	{
		value: 'mapbox://styles/mapbox/outdoors-v11',
		name: 'Outdoors'
	},
	{
		value: 'mapbox://styles/mapbox/light-v10',
		name: 'Light'
	},
	{
		value: 'mapbox://styles/mapbox/dark-v10',
		name: 'Dark'
	},
	{
		value: 'mapbox://styles/mapbox/satellite-v9',
		name: 'Satellite'
	},
	{
		value: 'mapbox://styles/mapbox/satellite-streets-v11',
		name: 'Satellite Streets'
	},
	{
		value: 'mapbox://styles/mapbox/navigation-day-v1',
		name: 'Navigation Day'
	},
	{
		value: 'mapbox://styles/mapbox/navigation-night-v1',
		name: 'Navigation Night'
	}
];

export const liveTrafficLayerId = 'live_traffic_layer';
export const liveTrafficOutlineLayerId = 'live_traffic_outline_layer';
export const liveTrafficDoubleOutlineLayerId = 'live_traffic_double_outline_layer';
export const liveTrafficTrailsLayerId = 'live_traffic_trails_layer';
export const liveTrafficSourceId = 'live_traffic_source';
export const selectedFeatureSourceId = 'selected_feature_source';
export const selectedFeatureLayerId = 'selected_feature_layer';
export const liveTrafficTrailsSourceId = 'live_traffic_trails_source';

export const operatingPictureSourceId = 'operating_picture_source';
export const operatingPictureLineLayerId = 'operating_picture_line_layer';
export const operatingPictureFillLayerId = 'operating_picture_fill_layer';
export const operatingPictureSymbolLayerId = 'operating_picture_symbol_layer';

export const ownshipCirclesSourceId = 'ownship_features_source';
export const ownshipFeaturesLineLayerId = 'ownship_features_line_layer';
export const ownshipTextLayerId = 'ownship_text_layer';
export const ownshipPointsSourceId = 'ownship_points_source';

export const streamsSourceId = 'streams_source';
export const streamsLayerId = 'streams_layer';

export const alwaysClickableLayers = [
	opsViewUsersCluserCircleLayerId,
	opsViewAircraftLayerId,
	opsViewUsersCircleLayerId,
	liveTrafficLayerId,
	operatingPictureFillLayerId,
	operatingPictureSymbolLayerId,
	streamsLayerId
];

export const noTranslateLayers = ['road-number-shield'];

export const greenLinePaintStyle = {
	'line-opacity': 1,
	'line-width': 6,
	'line-color': $success
};

export const greenFillPaintStyle = {
	'fill-opacity': 0.5,
	'fill-color': $success
};

export const defaultDrawingFillColor = 'rgba(54, 209, 138, .8)';

export { $white as defaultDrawingLineColor } from 'constants/styles';

export const ownshipLinePaint = {
	'line-width': 3,
	'line-color': $primary,
	'line-opacity': 0.75
};

export const ownshipLineLayout = {
	'line-cap': 'round',
	'line-join': 'round'
};

export const ownshipTextLayerPaint = {
	'text-color': $primary,
	'text-halo-color': $white,
	'text-halo-width': 4,
	'text-halo-blur': 1
};

export const ownshipTextLayerLayout = {
	'text-field': ['get', 'heading'],
	'text-size': [
		'interpolate',
		['linear'],
		['zoom'],
		8,
		8, // At zoom level 8, text size is 8
		15,
		30
	], // At zoom level 15, text size is 35
	'text-anchor': 'center',
	'text-allow-overlap': true,
	'text-padding': 5
};

export const fadeOpacityOver4700 = now => [
	'step',
	['-', now, ['get', 'timestamp']], // Calculate age in milliseconds
	1.0, // 0-2.35 seconds: opacity 1.0
	2350,
	0.8, // 2.35-2.82 seconds: opacity 0.8
	2820,
	0.6, // 2.82-3.29 seconds: opacity 0.6
	3290,
	0.4, // 3.29-3.76 seconds: opacity 0.4
	3760,
	0.2, // 3.76-4.23 seconds: opacity 0.2
	4230,
	0.1, // 4.23-4.7 seconds: opacity 0.1
	4700,
	0 // 4.7+ seconds: opacity 0
];

export const fadeOpacityOver10000 = now => [
	'step',
	['-', now, ['get', 'timestamp']], // Calculate age in milliseconds
	1.0, // 0-5 seconds: opacity 1.0
	5000,
	0.8, // 5-6 seconds: opacity 0.8
	6000,
	0.6, // 6-7 seconds: opacity 0.6
	7000,
	0.4, // 7-8 seconds: opacity 0.4
	8000,
	0.2, // 8-9 seconds: opacity 0.2
	9000,
	0.1, // 9-10 seconds: opacity 0.1
	10000,
	0 // 10+ seconds: opacity 0
];

export const getTrafficTrailsPaint = now => ({
	'line-width': 2,
	'line-color': $primary,
	'line-opacity': [
		'match',
		['get', 'aircraft_type'],
		'asterix',
		fadeOpacityOver10000(now),
		1 // Default opacity for non-asterix trails
	]
});

export const trafficTrailsLayout = {
	'line-cap': 'round',
	'line-join': 'round'
};

export const getSelectedCirclePaint = units => ({
	'circle-radius': ['interpolate', ['linear'], ['zoom'], 0, 4.5, 11, 24.5],
	'circle-color': [
		'case',
		// No altitude → transparent
		['!', ['has', 'altitude']],
		'rgba(0,0,0,0)',

		// High altitude
		['>=', ['get', 'altitude'], getHighAltitudeThresholdFt(units).value],
		$highAltitudeColor,

		// Mid altitude
		['>=', ['get', 'altitude'], getMidAltitudeThresholdFt(units).value],
		$midAltitudeColor,

		// Low altitude
		['>=', ['get', 'altitude'], lowAltitudeThreshold],
		$lowAltitudeColor,

		// Extremely low or invalid altitude (default fallback if < low)
		$lowAltitudeColor
	]
});

export const liveTrafficSymbolLayerLayout = {
	'icon-image': [
		'case',
		['==', ['get', 'is_sim'], true],
		'simulator_icon',
		[
			'match',
			['get', 'aircraft_type'],
			'uav',
			'drone_icon',
			'aircraft',
			'drone_icon',
			'adsb',
			[
				'match',
				['get', 'adsb_emitter_type'],
				'single_engine',
				'single_engine_airplane_icon',
				'jet',
				'jet_airplane_icon',
				'large',
				'large_airplane_icon',
				'helicopter',
				'helicopter_icon',
				'airplane_icon'
			],
			'asterix',
			'chevron_icon',
			'adsl',
			'chevron_icon',
			'rid',
			'drone_icon',
			'sensor',
			'radar_icon',
			'airplane_icon'
		]
	],
	'icon-allow-overlap': true,
	'icon-rotate': ['get', 'heading'],
	'icon-size': ['interpolate', ['linear'], ['zoom'], 0, 0.1, 11, 0.5]
};

export const trafficIconOpacity = now => [
	'match',
	['get', 'aircraft_type'],
	'asterix',
	fadeOpacityOver4700(now),
	1 // Default opacity for other aircraft types
];

export const getTrafficIconPaint = (selectedIds, units, now) => ({
	'icon-color': [
		'case',
		['in', ['get', 'id'], ['literal', selectedIds]],
		$black,
		[
			'step',
			['get', 'altitude'],
			$lowAltitudeColor, // Default color
			lowAltitudeThreshold,
			$lowAltitudeColor, // Low altitude exact color
			getMidAltitudeThresholdFt(units).value,
			$midAltitudeColor, // Mid altitude exact color
			getHighAltitudeThresholdFt(units).value,
			$highAltitudeColor // High altitude exact color
		]
	],
	'icon-opacity': trafficIconOpacity(now)
});

export const liveTrafficSymbolLayerOutlineLayout = {
	'icon-image': [
		'case',
		['==', ['get', 'is_sim'], true],
		'simulator_outline_icon',
		[
			'match',
			['get', 'aircraft_type'],
			'uav',
			'drone_outline_icon',
			'aircraft',
			'drone_outline_icon',
			'adsb',
			[
				'match',
				['get', 'adsb_emitter_type'],
				'single_engine',
				'single_engine_airplane_outline_icon',
				'jet',
				'jet_airplane_outline_icon',
				'large',
				'large_airplane_outline_icon',
				'helicopter',
				'helicopter_outline_icon',
				'airplane_outline_icon'
			],
			'asterix',
			'chevron_outline_icon',
			'adsl',
			'chevron_outline_icon',
			'rid',
			'drone_outline_icon',
			'sensor',
			'radar_outline_icon',
			'airplane_outline_icon'
		]
	],
	'icon-allow-overlap': true,
	'icon-rotate': ['get', 'heading'],
	'icon-size': ['interpolate', ['linear'], ['zoom'], 0, 0.1, 11, 0.5]
};

export const getLiveTrafficSymbolOutlinePaint = (selectedIds, now) => ({
	'icon-color': ['case', ['in', ['get', 'id'], ['literal', selectedIds]], 'transparent', $black],
	'icon-opacity': trafficIconOpacity(now)
});

export const liveTrafficSymbolLayerDoubleOutlineLayout = {
	'icon-image': [
		'case',
		['==', ['get', 'is_sim'], true],
		'simulator_double_outline_icon',
		[
			'match',
			['get', 'aircraft_type'],
			'uav',
			'drone_double_outline_icon',
			'aircraft',
			'drone_double_outline_icon',
			'adsb',
			[
				'match',
				['get', 'adsb_emitter_type'],
				'single_engine',
				'single_engine_airplane_double_outline_icon',
				'jet',
				'jet_airplane_double_outline_icon',
				'large',
				'large_airplane_double_outline_icon',
				'helicopter',
				'helicopter_double_outline_icon',
				'airplane_double_outline_icon'
			],
			'asterix',
			'chevron_double_outline_icon',
			'adsl',
			'chevron_double_outline_icon',
			'rid',
			'drone_double_outline_icon',
			'sensor',
			'radar_double_outline_icon',
			'airplane_double_outline_icon'
		]
	],
	'icon-allow-overlap': true,
	'icon-rotate': ['get', 'heading'],
	'icon-size': ['interpolate', ['linear'], ['zoom'], 0, 0.1, 11, 0.5]
};

export const getLiveTrafficSymbolDoubleOutlinePaint = (selectedIds, now) => ({
	'icon-color': ['case', ['in', ['get', 'id'], ['literal', selectedIds]], 'transparent', $white],
	'icon-opacity': trafficIconOpacity(now)
});

export const operatingPictureLinePaintStyle = {
	'line-opacity': 1,
	'line-width': 6,
	'line-color': [
		'match',
		['get', 'status'],
		'APPROVED',
		$success,
		'ACTIVE',
		$success,
		'PENDING',
		$elevated,
		/* other */ '#fff'
	]
};

export const operatingPictureFillPaintStyle = {
	'fill-opacity': 0.5,
	'fill-color': [
		'match',
		['get', 'status'],
		'APPROVED',
		$success,
		'ACTIVE',
		$success,
		'PENDING',
		$elevated,
		/* other */ '#fff'
	]
};

export const operatingPictureSymbolPaintStyle = {
	'icon-color': [
		'match',
		['get', 'status'],
		'APPROVED',
		$success,
		'ACTIVE',
		$success,
		'PENDING',
		$elevated,
		/* other */ '#fff'
	]
};

export const getPhoneIconPaint = selectedIdsArray => ({
	'icon-color': [
		'case',
		['in', ['get', 'id'], ['literal', selectedIdsArray]],
		'#FF69B4', // color if ID is in the array
		$black // default color
	]
});

export const userLocationSourceId = 'user_location';
